import './warningMessage.scss';

import React, { FunctionComponent } from 'react';

import Svg from '@justgiving/svg';
import { alertIcon } from '@justgiving/icons';

type WarningMessageProps = {
  message: string;
};

export const WarningMessage: FunctionComponent<WarningMessageProps> = ({
  message,
}) => {
  return (
    <div className="warningMessage">
      <Svg
        className="jg-icon jg-icon--medium-small warningMessage__icon"
        markup={alertIcon}
        aria-hidden={true}
      />
      <span>{message}</span>
    </div>
  );
};
